import type { Node, RichContent } from './../../ricos-schema/legacy/wix/rich_content/v1';
import { Node_Type } from './../../ricos-schema/legacy/wix/rich_content/v1';

import type { DraftContent } from '../types';

export const isContentStateEmpty = (contentState: DraftContent): boolean => {
  const { blocks } = contentState;
  if (blocks.length === 0) {
    return true;
  }
  if (blocks.length > 1) {
    return false;
  }
  const firstBlock = blocks[0];
  const { text, type, depth } = firstBlock;
  return text === '' && type === 'unstyled' && depth === 0;
};

export const isRichContentEmpty = (contentState: RichContent): boolean => {
  if (contentState.nodes?.length === 0) {
    return true;
  } else if ((contentState.nodes?.length ?? 0) > 1) {
    return false;
  } else {
    const firstNode = contentState.nodes?.[0];
    const { nodes, type, paragraphData } = firstNode as Node;
    return (
      nodes?.length === 0 &&
      type === Node_Type.PARAGRAPH &&
      [undefined, 0].includes(paragraphData?.indentation)
    );
  }
};
